import axios from "axios";
import apiConfig from './api.config';
class NewsDataService {
    getAll() {
        return axios.get(`/noticias?sort=Fecha:DESC&populate=*`, apiConfig.connData());
    }
    get(id) {
        return axios.get(`/noticias/${id}?populate=*`, apiConfig.connData());
    }
}
export default new NewsDataService();